import { Dropdown } from "react-bootstrap";
import { getAccountCurrencyByAccountCurrencyIdAsync, deleteAccountCurrencyAsync, checkedState, unCheckedState, checkedAllState, unCheckedAllState, updateAccountCurrencyAsync, updateAccountCurrencyId,updateSorting } from "./CurrenciesSlice";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { BrowserRouter as Router, Route, Link,useNavigate } from 'react-router-dom';
import { ShowSwalWithConfirmation } from '../../../common/SweetAlert';
import { ShowToast } from '../../../common/Toastr';
import clsx from "clsx";
import { FormatInvoiceDecimalNumber, setItemStatus, FormatNumberCultureAware} from '../../../common/timeLiveFunction';
import { getValueFromResource } from "../../../common/timeLiveFunction";
const itemClass = 'ms-1 ms-lg-0';
export const CurrenciesItem = (props: any) => {
    const dispatch = useAppDispatch();
    const { CurrenciesList, onToggleModal, AccountBaseCurrencyId, t, IsEdit, IsDelete } = props;
    const { sortOrder, sortColumn, pageSize } = useAppSelector((state) => state.currencies);
      const { cultureInfoName,decimalPlaces } = useAppSelector((state) => state.globalState);

    const navigate = useNavigate();
    const onDeleteClick = (AccountCurrencyId: any) => {
        ShowSwalWithConfirmation('Are you sure you want to delete this record?', "")
            .then((result) => {
                if (result) {
                    dispatch(deleteAccountCurrencyAsync(AccountCurrencyId))
                        .unwrap()
                        .then((originalPromiseResult) => {
                            originalPromiseResult.StatusCode === "200" ?
                                ShowToast("Currency Delete Successfully", 'Success', "success", "toast-top-right") :
                                ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
                        })
                        .catch((rejectedValueOrSerializedError) => {
                        })
                }
            })
            .catch((error) => {
            });
    }
    const handleCheckboxChange = (e: any, rowId: any) => {
        if (e.target.checked) {
            dispatch(checkedState(rowId))
        } else {
            dispatch(unCheckedState(rowId))
        }
    };

    const handleSelectAllChange = (e: any) => {
        const { checked } = e.target;
        if (checked) {
            dispatch(checkedAllState());
        } else {
            dispatch(unCheckedAllState());
        }
    };

    const onEditClick = (AccountCurrencyId: any) => {
        dispatch(getAccountCurrencyByAccountCurrencyIdAsync(AccountCurrencyId))
            .unwrap()
            .then((originalPromiseResult) => {
                onToggleModal();
            })
            .catch((rejectedValueOrSerializedError) => {
            })
    }
    const handleIsDisabledChange = (e: any, currenciesDetail: any) => {
        const { checked } = e.target;
        const foundIndex = CurrenciesList.findIndex((item: any) => item.AccountCurrencyId === currenciesDetail.AccountCurrencyId);
        if (foundIndex !== -1) {
            const foundItem = CurrenciesList[foundIndex];
            const { isSelected, ...updatedItem } = foundItem;
            updatedItem.Disabled = checked;
            const modifiedList = [...CurrenciesList.slice(0, foundIndex), updatedItem, ...CurrenciesList.slice(foundIndex + 1)];
            dispatch(updateAccountCurrencyAsync(updatedItem))
                .unwrap()
                .then((originalPromiseResult) => {
                    ShowToast("Currency Update Successfully", 'Success', "success", "toast-top-right"); 
                })
                .catch((rejectedValueOrSerializedError) => {
                })
        }
    }

    const navigateToCurrencyRateHistory = (obj: any) => {
        // navigate('/currencyexchangerates', { state: { obj } });
        navigate(`/currencyexchangerates/${obj.AccountCurrencyId}`,{state: {CurrencyName: obj?.CurrencyName}});
        dispatch(updateAccountCurrencyId(obj.AccountCurrencyId));
    };
    const onHandleClientSideSorting = (sortOrder: string, sortColumn: string) => {
        dispatch(updateSorting({
            "sortOrder": sortOrder,
            "sortColumn": sortColumn,
            "pageSize": pageSize,
            "pageNo": 1
        }));
    }



    return (
        <>
            <table className="table table-row-bordered  align-middle gs-1 gy-1 gx-1" >
                <thead>
                    <tr className="thHeading align-middle "  >
                    <th style={{ width: '15%' }}>
                        {/* {t('Active / Inactive')} */}
                        {getValueFromResource('Active / Inactive',dispatch, t)}
                        {sortColumn === 'Disabled' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "Disabled") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "Disabled") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "Disabled") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "Disabled") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                        </th>
                        <th style={{ width: '35%' }}>
                            {/* {t('Name')} */}
                            {getValueFromResource('Name',dispatch, t)}

                        {sortColumn === 'Currency' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "Currency") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "Currency") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "Currency") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "Currency") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                        </th>
                        <th style={{ width: '15%' }}>
                            {/* {t('Symbol')} */}
                            {getValueFromResource('Symbol',dispatch, t)}

                        {sortColumn === 'CurrencyCode' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "CurrencyCode") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "CurrencyCode") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "CurrencyCode") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "CurrencyCode") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                        </th>
                        <th style={{ width: '15%' }}>
                            {/* {t('Exchange Rate')} */}
                            {getValueFromResource('Exchange Rate',dispatch, t)}

                        {sortColumn === 'ExchangeRate' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "ExchangeRate") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "ExchangeRate") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "ExchangeRate") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "ExchangeRate") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                        </th>
                        {/* {IsEdit &&
                            <th className='min-w-100%'>{t('Active / Inactive')}</th>
                        } */}
                        <th className='min-w-100% text-end '></th>
                    </tr>
                </thead>
                <tbody>
                    {CurrenciesList.length === 0 && <tr><td colSpan={5}><p className='noDataFound'>
                        {/* {t('No Record Found')} */}
                        {getValueFromResource('No Record Found',dispatch, t)}

                        </p></td></tr>}
                    {CurrenciesList.length > 0 && CurrenciesList.map((currenciesDetail: any, i: any) => (
                        <tr key={i}>
                            <td>
                                <span className={clsx('timeOffStatus-td app-navbar-item badge ', setItemStatus(currenciesDetail.Disabled === 'No' ? "Active" : "InActive"))}>
                                    {currenciesDetail.Disabled === 'No' ? "Active" : "InActive"}
                                </span>
                            </td>
                            <td className='text-gray-800  text-hover-primary custom-pointer-cursor '
                                onClick={IsEdit ? () => onEditClick(currenciesDetail.AccountCurrencyId) : undefined}
                            >
                                <span className="d-block">{currenciesDetail.Currency}</span>
                            </td>
                            <td>
                                <span className="d-block">{currenciesDetail.CurrencyCode}</span>
                            </td>
                            <td>
                                <span className="d-block">{FormatNumberCultureAware(cultureInfoName.toString(), currenciesDetail.ExchangeRate)}</span>
                            </td>
                            {/* {IsEdit &&
                                <td className='text-center'>
                                    <div className="form-check form-switch form-check-custom">
                                         <input
                                            type="checkbox"
                                            className="form-check-input custom-padding-right h-15px w-30px"
                                            id="IsDisabled"
                                            checked={currenciesDetail.Disabled === 'Yes' ? true : false}
                                            onChange={(e) => { handleIsDisabledChange(e, currenciesDetail) }}
                                        /> 
                                        
                                    </div>
                                </td>
                            } */}
                             <td className='text-center'>
                                <Dropdown
                                    style={{ marginLeft: 1 }}
                                    className={clsx('cursor-pointer symbol')}
                                    data-kt-menu-attach='parent'
                                    data-kt-menu-placement='bottom-end'
                                >
                                    <Dropdown.Toggle
                                        variant="transparent"
                                        className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                                        data-tooltip-id="tooltip-Description"
                                        data-tooltip-content=
                                        // {t("More")}
                                        {getValueFromResource('More',dispatch, t)}
                                        data-tooltip-place="top"
                                    >
                                        <i className="bi bi-three-dots fs-7"></i>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 px-1 py-1 fs-2 w-150px'>

                                            {AccountBaseCurrencyId !== currenciesDetail.AccountCurrencyId && IsEdit &&
                                                <>
                                                    <div className='menu-hover-bg-sec'>
                                                        <Dropdown.Item
                                                            className="menu-item me-lg-0 "
                                                            onClick={() => { onEditClick(currenciesDetail.AccountCurrencyId) }}
                                                        >
                                                            <span className="menu-icon custom-menu">
                                                                <i className="bi bi-pencil-square fs-6 iconColor allign">
                                                                    <span className="path1"></span>
                                                                    <span className="path2"></span>
                                                                </i>
                                                            </span>
                                                            <span className="menu-title custom-menu-fontsize">
                                                                {/* {`${t('Edit')}`} */}
                                                                {getValueFromResource('Edit',dispatch, t)}
                                                                </span>
                                                        </Dropdown.Item>
                                                    </div>
                                                </>
                                            }
                                            <>
                                                {/* <div className='menu-hover-bg-sec'>
                                                    <Dropdown.Item
                                                        className="menu-item me-lg-0 "
                                                    >
                                                        <span className="menu-icon custom-menu">
                                                            <i className="bi bi-clock-history iconColor fs-6">
                                                                <span className="path1"></span>
                                                                <span className="path2"></span>
                                                            </i>
                                                        </span>
                                                        <span className="menu-title custom-menu-fontsize">
                                                            <Link to={`../currencyExchangeRates?AccountCurrencyId=${currenciesDetail.AccountCurrencyId}`}  >
                                                                {t('History')}
                                                            </Link>
                                                        </span>
                                                    </Dropdown.Item>
                                                </div> */}
                                                  <div className='menu-hover-bg-pri'>
                                                <Dropdown.Item
                                                    className="menu-item me-lg-0"
                                                    onClick={() => {
                                                        navigateToCurrencyRateHistory({
                                                            "AccountCurrencyId": currenciesDetail.AccountCurrencyId,
                                                            "CurrencyName": currenciesDetail.Currency
                                                        });
                                                    }}
                                                >
                                                    <span className="menu-icon custom-menu">
                                                        <i className="bi bi-receipt fs-6">
                                                            <span className="path1"></span>
                                                            <span className="path2"></span>
                                                        </i>
                                                    </span>
                                                    <span className="menu-title custom-menu-fontsize">
                                                        {/* {`${t('Details')}`} */}
                                                        {getValueFromResource('Rate History',dispatch, t)}

                                                        </span>
                                                </Dropdown.Item>
                                               
                                            </div>
                                            </>
                                            {IsDelete && IsEdit && (currenciesDetail.MasterAccountCurrencyId === null || currenciesDetail.MasterAccountCurrencyId === 0) &&
                                                <div className='separator mb-1 mt-1 opacity-75 '></div>
                                            }
                                            {AccountBaseCurrencyId != currenciesDetail.AccountCurrencyId && IsDelete && (currenciesDetail.MasterAccountCurrencyId === null || currenciesDetail.MasterAccountCurrencyId === 0) &&
                                                <>
                                                    <div className='menu-hover-bg-danger'>
                                                        <Dropdown.Item
                                                            className="menu-item me-lg-0 "
                                                            onClick={() => { onDeleteClick(currenciesDetail.AccountCurrencyId) }}>
                                                            <span className="menu-icon  custom-menu">
                                                                <i className="bi bi-trash fs-6 delete-menu-icon-color allign" >
                                                                    <span className="path1"></span>
                                                                    <span className="path2"></span>
                                                                </i>
                                                            </span>
                                                            <span className="menu-title   delete-menu custom-menu-fontsize"  >
                                                                {/* {`${t('Delete')}`} */}
                                                                {getValueFromResource('Delete',dispatch, t)}

                                                                </span>
                                                        </Dropdown.Item>
                                                    </div>
                                                </>
                                            }
                                        </Dropdown.Menu>
                                    </Dropdown>
                            </td>
                        </tr>
                    ))}

                </tbody>
            </table >
        </>
    )
}
